export default __webpack_public_path__ + "6e7ea939168bad0d33f07ef81d06a0d7.woff";